import { render, staticRenderFns } from "./ApprovalsStatus.vue?vue&type=template&id=5b5b7662&"
import script from "./ApprovalsStatus.vue?vue&type=script&lang=js&"
export * from "./ApprovalsStatus.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalsStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports